// React
import React from 'react';
//Styles
import useStyles from './CustomReadOnlyHourInterval.styles';
import classNames from 'classnames';
import Conditional from '../conditional/Conditional';
const CustomReadOnlyHourInterval = ({ classes, open, close }) => {
  const componentClasses = useStyles();
  const showCloseBox = !!open || !!close;
  const openDisplay = !!open ? open : '-';
  const closeDisplay = !!close ? close : '-';

  return (
    <div className={classNames(componentClasses.root)}>
      <div className={classNames(componentClasses.boxOpen)}>{openDisplay}</div>
      <Conditional if={showCloseBox}>
        <div className={classNames(componentClasses.boxClose)}>
          {closeDisplay}
        </div>
      </Conditional>
    </div>
  );
};

CustomReadOnlyHourInterval.defaultProps = {
  classes: {},
};

export default CustomReadOnlyHourInterval;
